module.exports = __webpack_public_path__ + "assets/img/ddae1ea30b02d00b9734f0e0e2c3d848.png";